"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCssValueAST = exports.isSeparatorToken = void 0;
const core_1 = require("../core");
const helpers_1 = require("../helpers");
exports.isSeparatorToken = (token) => {
    const { type } = token;
    return (type === "line-comment" || type === "multi-comment" || type === "space");
};
function createCssValueAST(source, parseLineComments = false) {
    return parseDeclValueTokens(source, core_1.tokenize(source, {
        isDelimiter,
        isStringDelimiter: helpers_1.isStringDelimiter,
        isWhitespace: helpers_1.isWhitespace,
        shouldAddToken,
        createToken: helpers_1.createToken,
        getCommentStartType: parseLineComments
            ? helpers_1.getJSCommentStartType
            : helpers_1.getMultilineCommentStartType,
        isCommentEnd: helpers_1.isCommentEnd,
        getUnclosedComment: helpers_1.getUnclosedComment,
    })).ast;
}
exports.createCssValueAST = createCssValueAST;
const isDelimiter = (char) => char === "(" || char === ")" || char === ",";
const shouldAddToken = () => true;
function parseDeclValueTokens(source, tokens, startAtIdx = 0) {
    var _a;
    const ast = [];
    let before = [];
    for (let i = startAtIdx; i < tokens.length; i++) {
        const token = tokens[i];
        if (token.type === ")") {
            const lastAst = ast[ast.length - 1];
            if (lastAst && before.length) {
                lastAst.after = before;
                before = [];
            }
            return {
                ast,
                stoppedAtIdx: i,
            };
        }
        else if (exports.isSeparatorToken(token)) {
            before.push(token);
        }
        else if (token.type === "text" && ((_a = tokens[i + 1]) === null || _a === void 0 ? void 0 : _a.type) === "(") {
            const res = parseDeclValueTokens(source, tokens, i + 2);
            const methodText = helpers_1.getText(tokens, i, res.stoppedAtIdx + 1, source);
            i = res.stoppedAtIdx;
            ast.push({
                type: "call",
                text: methodText,
                start: token.start,
                end: token.start + methodText.length,
                before,
                after: [],
                name: token.value,
                args: res.ast,
            });
            before = [];
        }
        else {
            ast.push({
                type: token.type,
                text: token.value,
                start: token.start,
                end: token.end,
                before,
                after: [],
            });
            before = [];
        }
    }
    return {
        ast,
        stoppedAtIdx: tokens.length,
    };
}
//# sourceMappingURL=css-value-tokenizer.js.map